"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableEntityPrefix = void 0;
var TableEntityPrefix;
(function (TableEntityPrefix) {
    TableEntityPrefix["Products"] = "PRODUCTS:";
    TableEntityPrefix["PriorityTasks"] = "PRIORITY_TASKS:";
    TableEntityPrefix["HLQATaskView"] = "HLQA_TASK_VIEW:";
})(TableEntityPrefix || (exports.TableEntityPrefix = TableEntityPrefix = {}));
